import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  openAddFromTemplate({ component: pageComponent });
}

export function openAddFromTemplate({ component } = {}) {
  component.setState({ jobOverlayAddFromTemplateShow: true });
  setTimeout(() => {
    component.jobOverlayAddFromTemplate.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [] });
    setTimeout(() => {
      component.jobOverlayAddFromTemplate.current?.getOverlayOption();
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function formatData({ parameter } = {}) {
  let data = parameter.map((item, i) => {
    let iconFormat = [];
    if (item.Applicable === true) {
      //如果 Applicable 是true, actionType 是 Applicable 的 图标设置用第2个图片
      iconFormat.push({ actionType: 'Applicable', iconIndex: 1 });
    }
    if (iconFormat.length > 0) item.IconFormat = iconFormat;
    return item;
  })
  return data;
}

//点击前面的灰色√更改状态
export function applicable({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let jobOverlay = globalFunction.getSectionComponent(pageComponent, 'JobOverlay');
  let oldData = jobOverlay.child.current?.state.data;
  let newData = oldData.map((item, i) => {
    if (item.key === parameter.key) {
      item.IconFormat = [{ actionType: 'Applicable', iconIndex: 2 }];
    }
    return item;
  })

  httpClient
  .put('Business/JobOverlay/UpdateApplicable', parameter)
  .then(({ data }) => {
    if (data.result) {
      setTimeout(() => {
        sectionComponent.getSectionDataByDefault();
      }, config.setTimeoutMilliSecond);
    } else {
      globalFunction.handleResultError(data, pageComponent);
    }
  })
  .catch(function (error) {
    globalFunction.handleError(error, pageComponent);
  });
}
